module.exports = __webpack_public_path__ + "media/images/championship__iconPickTeam-1836febf6bcaf1e9b7090971b092f0db.png";